import React from "react";
// @ts-ignore
import Slider, { Settings } from "react-slick"; 
import styled from "styled-components";

interface MultiCardCarouselProps {
  children: React.ReactNode;
  settings?: Settings;
}

/**
 * Default settings for the MultiCardCarousel.
 * Adjusted slidesToShow to 3.8 so cards appear a bit smaller and fully visible.
 */
const defaultSettings: Settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
        }
    },
    {
        breakpoint: 800,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
        }
    },
    {
        breakpoint: 640,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
};

const CarouselContainer = styled.div`
  width: 100%;
  padding: 0 20px;
`;

const SlideWrapper = styled.div`
  padding: 0 5px; // horizontal gap
  box-sizing: border-box;
`;

/**
 * MultiCardCarousel component
 *
 * Wraps react-slick's Slider with default (and overrideable) settings.
 */
const MultiCardCarousel: React.FC<MultiCardCarouselProps> = ({
  children,
  settings,
}) => {
  // Merge default settings with any overrides passed via props.
  const carouselSettings = { ...defaultSettings, ...settings };

  return (
    <CarouselContainer>
      <Slider {...carouselSettings}>
      {React.Children.map(children, (child) => (
          <SlideWrapper>{child}</SlideWrapper>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default MultiCardCarousel;